"use client"

import { Card } from "@/components/ui/card"
import { useState } from "react"

interface FloatingCardProps {
  children: React.ReactNode
  className?: string
  /** Show a pointer cursor. Off by default — these cards are decorative unless a
   *  consumer wires a whole-card click, so a pointer would be a false affordance. */
  clickable?: boolean
}

export function FloatingCard({ children, className = "", clickable = false }: FloatingCardProps) {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <Card
      className={`
        transition-all duration-500 ease-out hover-elevate
        ${clickable ? "cursor-pointer" : ""}
        ${
          isHovered
            ? "transform -translate-y-2 shadow-2xl shadow-primary/10 scale-[1.02]"
            : "transform translate-y-0 shadow-lg hover:shadow-xl"
        }
        ${className}
      `}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      data-testid="floating-card"
    >
      {children}
    </Card>
  )
}